/**
 * Response Data Transfer Object
 */
export interface ResponseDTO {
	/**
	 * Status Code
	 */
	code: number
	/**
	 * Status Message
	 */
	message: string
	/**
	 * Data
	 */
	data?: Record<string, unknown>
}
